import React, { FC, useRef } from "react";
import type { EcosystemCrossBorderPaymentsProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import { TextCols } from "../text-cols";
import { useInView } from "@/hooks/reveal-in-view";

export const EcosystemCrossBorderPayments: FC<EcosystemCrossBorderPaymentsProps> = ({
  content,
  cards,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="ecosystemCrossBorderPayments">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={766} />
      </div>
      <div className="wrapper wrapper_lg">
        <div className="ecosystemCrossBorderPayments--cards" ref={ref}>
          {cards.map((card, index) => {
            return (
              <div
                key={index}
                className="ecosystemCrossBorderPayments--card"
                onMouseEnter={(event) => {
                  const target = event.currentTarget as HTMLElement;
                  target.classList.add("hover-animation-bounce");
                }}
                onAnimationEnd={(event) => {
                  const target = event.target as HTMLElement;
                  target.classList.remove("hover-animation-bounce");
                }}
              >
                {card.image?.file?.url && (
                  <Image
                    className="ecosystemCrossBorderPayments--card-icon"
                    noInline
                    src={card.image as any}
                    alt={card.image.title}
                    style={{
                      transform: isInView
                        ? "none"
                        : `translateY(${40 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                    }}
                    options={{
                      sizes: {
                        exec: [
                          {
                            width: 48,
                            height: 48,
                          },
                        ],
                      },
                    }}
                  />
                )}
                {card.title && (
                  <ContentManager
                    content={card.title}
                    className="ecosystemCrossBorderPayments--card-title"
                    style={{
                      transform: isInView
                        ? "none"
                        : `translateY(${40 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                    }}
                  />
                )}
                {card.description && (
                  <ContentManager
                    content={card.description}
                    className="ecosystemCrossBorderPayments--card-description"
                    style={{
                      transform: isInView
                        ? "none"
                        : `translateY(${40 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
